module.exports = __webpack_public_path__ + "static/media/services.8be7fe89.png";